module.exports = __webpack_public_path__ + "media/images/monthly10-45cb28c8657d7787a09753ec619baab6.jpg";